// extracted by mini-css-extract-plugin
export default {"promote":"PromoteButton__promote--onQzEP"};